import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import Box from '@material-ui/core/Box';
import MenuItem from '@material-ui/core/MenuItem';
import { useSelector, useDispatch } from "react-redux";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { portfolioDetailsActions } from "./../../actions/portfolio/portfolio-details.actions"
import { useParams } from 'react-router';

const useStyles = makeStyles((theme) => ({
  button: {
    color: "#fff",
    textTransform: "uppercase",
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 4,
    padding: "4px 8px",
  },
  icon: {
    fontSize: 12,
  },
  menuItem: {
    fontSize: 12,
    display: 'flex',
    alignItems: "center"
  },
  status: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    marginRight: 8,
    textTransform: "uppercase",
  }
}))

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
));

export function StatusMenu({ selectedStatus, allStatus, type, id }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { id: projectId } = useParams();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { loadingUpdateTask } = useSelector(state => state.portfolioDetails)
  const { projectTasksStatus } = useSelector(state => state.domains);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleChangeStatus(data, id) {
    return () => dispatch(portfolioDetailsActions.changeStatus(type, { taskStatus: { ...data } }, id, { 
      page: 1,
      limit: 10,
      taskStatusCode: selectedStatus?.code,
      projectId: projectId
    }, projectTasksStatus))
  }

  return (
    <div>
      <Button
        aria-haspopup="true"
        variant="contained"
        onClick={handleClick}
        style={{ backgroundColor: `${selectedStatus?.color}` }}
        disabled={loadingUpdateTask}
        className={classes.button}
      >
        <Box display="flex" alignItems="center">
          { selectedStatus?.name } &nbsp;&nbsp;|&nbsp;&nbsp;<ExpandMoreIcon fontSize='inherit' />
        </Box>
      </Button>
      <StyledMenu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        { allStatus.filter(item => item.code !== selectedStatus?.code).map(item => (
          <MenuItem className={classes.menuItem} key={item._id} onClick={handleChangeStatus(item, id)} disabled={loadingUpdateTask} >
            <Box className={classes.status} style={{ backgroundColor: item.color}} />
            { item.name }
          </MenuItem>
        ))} 
      </StyledMenu>
    </div>
  );
}